import { useMutation } from "@tanstack/react-query";

import { useAuthFetch } from "shared/providers/auth/use-auth-fetch";

// const calendarScope = [
//   "https://www.googleapis.com/auth/calendar.readonly",
//   "https://www.googleapis.com/auth/calendar",
// ];
// const gmailScope = [
//   "https://www.googleapis.com/auth/gmail.readonly",
//   "https://www.googleapis.com/auth/gmail.modify",
// ];
// const driveScope = [
//   "https://www.googleapis.com/auth/drive.readonly",
//   "https://www.googleapis.com/auth/drive",
// ];

// const contactsScope = [
//   "https://www.googleapis.com/auth/contacts.readonly",
//   "https://www.googleapis.com/auth/contacts",
// ];

type Params = {
  scopes: string[];
  label: string;
  instructions: string;
};

export const useAuthRedirectLinkMutation = () => {
  const fetch = useAuthFetch();
  return useMutation({
    mutationFn: async (params: Params) => {
      const { scopes, label, instructions } = params;

      console.log(scopes);
      const response = await fetch(
        `${import.meta.env.VITE_BACKEND_URL}/google-auth?scopes=email,profile,${scopes}&label=${label}&instructions=${instructions}`
      );
      const { url }: { url: string } = await response.json();

      return url;
    },
  });
};
